<template>
  <div class="pl-auth-container">
    <div v-if="banners.length > 0" class="pl-auth-banners">
      <a
        v-for="(banner, index) in banners"
        :key="index"
        :href="banner.url"
        :style="{ 'background-image': 'url(' + API_URL + banner.image.url + ')' }"
        class="pl-banner"/>
    </div>

    <div v-else class="pl-auth-banners">
      <div class="pl-banner"></div>
    </div>

    <div class="pl-auth-forms">
      <div class="pl-auth-content">
        <img src="../assets/logo-admin.png" alt="Range Selection" class="pl-auth-logo">

        <p class="pl-auth-text">
          Para acessar nosso sistema premium de Ranges,
          basta usar as mesmas credenciais da
          <strong>Plataforma PokerLAB (seu e-mail e senha):</strong>
        </p>

        <form class="pl-auth-form" @submit.prevent="submit">
          <transition name="fade">
            <div v-if="form.isFailed" class="pl-auth-alert">
              <span class="pl-auth-alert__label">{{ form.message }}</span>
            </div>
          </transition>

          <div class="pl-auth-form__field">
            <input
              id="email"
              class="pl-auth-form__input"
              type="email"
              name="email"
              placeholder="seu@email.com"
              v-model="form.email"
              required>
            <label class="pl-auth-form__label" for="email">E-mail</label>
            <simple-svg
              :filepath="'/img/svg/icon-mail.svg'"
              class="pl-auth-form__icon"/>
          </div>

          <div class="pl-auth-form__field">
            <input
              id="password"
              class="pl-auth-form__input"
              type="password"
              name="password"
              placeholder="Sua senha"
              v-model="form.password"
              required>
            <label class="pl-auth-form__label" for="password">Senha</label>
            <simple-svg
              :filepath="'/img/svg/icon-password.svg'"
              class="pl-auth-form__icon"/>
            <a
              tabindex="-1"
              class="pl-auth-form__link"
              href="https://membros.pokerlab.com.br/usuarios/senha/new"
              target="_blank">Esqueceu sua senha?</a>
          </div>

          <div class="pl-auth-form__submit">
            <button
              class="pl-auth-form__btn"
              type="submit"
              :disabled="form.isDisabled">Entrar</button>
          </div>
        </form>
      </div>

      <a class="pl-auth-author" href="https://vfx3.com.br/">
        powered by
        <simple-svg
        :filepath="'/img/svg/vfx.svg'"
        class="pl-auth-author__logo"/>
      </a>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapActions } from 'vuex'
import axios from '@/plugins/axios'

export default {
  name: 'LoginForm',

  data () {
    return {
      form: {
        email: '',
        password: '',
        message: '',
        isDisabled: false,
        isFailed: false
      },
      banners: [],
      token: ''
    }
  },

  computed: {
    API_URL () {
      return process.env.VUE_APP_API_BASE_URL ? process.env.VUE_APP_API_BASE_URL : 'http://localhost:3000'
    }
  },

  methods: {
    ...mapActions('auth', ['logIn', 'setUser']),

    submit () {
      const email = this.form.email
      const password = this.form.password
      this.form.isDisabled = true
      this.form.isFailed = false

      this.logIn({ email, password })
        .then(token => {
          this.token = token
          this.firebaseAuth()
        })
        .catch((error) => {
          this.form.isDisabled = false
          this.setFailedAuth(error.response)
        })
    },

    firebaseAuth () {
      firebase.auth().signInWithCustomToken(this.token)
        .then(() => this.successRedirect())
        .catch((error) => {
          this.setFailedAuth(error.response)
        })
    },

    successRedirect () {
      const redirectTo = this.$route.query.redirectTo || { name: 'home' }
      this.form.isDisabled = false
      this.$router.push(redirectTo)
    },

    setFailedAuth (response) {
      this.form.isFailed = true

      if (response) {
        if (response.status === 401) {
          this.form.message = 'E-mail ou Senha incorretos'
        }
      } else {
        this.form.message = 'Conexão com o servidor falhou'
      }

      setTimeout(() => {
        this.form.isFailed = false
      }, 4000)
    }
  },

  mounted () {
    axios
      .get('/api/v1/ad_banner?id=1')
      .then(response => {
        this.banners = response.data.data
      })
      .catch(error => console.log(error))
  }
}
</script>
